import React, { useEffect, useState } from "react";
import {
  Heading,
  Box,
  Flex,
  Square,
  Button,
  CircularProgress,
  CircularProgressLabel,
  Spinner,
} from "@chakra-ui/react";

const UpdateToast = ({ onPostpone }) => {
  const [time, setTime] = useState(30);
  const percentageLeft = (time / 30) * 100;
  const update = () => {
    window.location.reload();
  };

  useEffect(() => {
    let timer = setInterval(() => {
      setTime((time) => {
        if (time === 0) {
          clearInterval(timer);
          update();
          return 0;
        } else return time - 1;
      });
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Box
      color="brand.primary.600"
      bg="white"
      borderRadius={"lg"}
      boxShadow={"lg"}
    >
      <Flex p={2}>
        <Square>
          <CircularProgress
            size="50px"
            value={percentageLeft}
            thickness="6px"
            color="brand.primary.500"
          >
            <CircularProgressLabel color={"brand.primary.700"}>
              {time || <Spinner size="xs" mt={1} />}
            </CircularProgressLabel>
          </CircularProgress>
        </Square>
        <Box flex="1" textAlign={"center"}>
          <Heading size={"sm"} mb={2}>
            New Update Pending...
          </Heading>
          <Button
            variant={"solid"}
            bg="brand.primary"
            size="sm"
            onClick={onPostpone}
            data-testid={"postpone-update"}
          >
            Postpone
          </Button>
          <Button
            variant={"solid"}
            bg="brand.primary"
            size="sm"
            ml="2"
            onClick={update}
            data-testid={"update"}
          >
            Update
          </Button>
        </Box>
      </Flex>
    </Box>
  );
};

export default UpdateToast;
